import React, { useEffect, useState } from "react";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";
import { Popup } from "../Global/Popup";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { HalfCircleSpinner } from "react-epic-spinners";
import { Rating } from "react-simple-star-rating";

import Header from "../Global/Header";
import ItemComment from "./ItemComment";

const Comments = (props) => {
  const [rating, setRating] = useState(0);
  const [state, setState] = useState({
    data: [], // data news
    loader: true, // loader status
    loading: true, // animation
    inputValue: "", // input value
    validInput: false, // validation input value
    loaderPage: false, // loader api set comment
    popup: false,
    textApi: "",
  });
  const handleRating = (rate) => {
    const newRate = rate;
    setRating(newRate);
  };
  useEffect(() => {
    document.getElementById("cmnt").classList.add("active");


    base_url
      .get(`item_comment/${props.match.params.id}`,)
      .then((response) => {
        setState({
          ...state,
          data: response.data.itemComments.reverse(),
          loader: false,
          loading: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  const handleInput = (e) => {
    setState({
      ...state,
      inputValue: e.target.value,
      validInput: false,
    });
  };

  const handleSetComment = () => {
    if (state.inputValue.length !== 0) {
      setState({
        ...state,
        loaderPage: true,
        inputValue: "",
      });
      const Data = {
        item_id: props.match.params.id,
        comment: state.inputValue,
        rate: rating / 20,
      };
      base_url
        .post(`item_comment`, Data)
        .then((response) => {
          setState({
            ...state,
            loaderPage: false,
            popup: true,
            textApi:
              response.data.length == 0
                ? "نظر شما با ما موفقیت ثبت شد."
                : response.data[0],
            inputValue: "",
          });
          setRating(0);
        })
        .catch((error) => {
          if (error.response != undefined) {
            setState({
              ...state,
              loaderPage: false,
              textApi: "مشکلی به وجود آمده لطفا دوباره سعی کنید.",
              popup: false,
            });
            if (error.response.status == 401) {
              props.history.push(`/Entrance`);
            }
          }
        });
    } else {
      setState({
        ...state,
        validInput: true,
        inputValue: "",
      });
      setRating(0);
    }
  };
  return (
    <React.Fragment>
      <Loader active={state.loaderPage} />
      <div id="cmnt" className="comments">
        <Header innerPage={true} title={"نظرات"} />
        <Popup active={state.popup}>
          <h4>{state.textApi}</h4>
          <div className="btn-base btn-black btn-sircle">
            <Button
              variant="contained"
              onClick={() => setState({ ...state, popup: false })}
            >
              خروج
            </Button>
          </div>
        </Popup>
        <div className="inner-comments">
          <div className="create-cmnt">
            <h4>ثبت نظر</h4>
            <div className="comment-card">
              <div className="input-form">
                <TextField
                  id="standard-basic"
                  label="متن پیام"
                  multiline
                  rows={3}
                  value={state.inputValue}
                  onChange={(e) => handleInput(e)}
                />
                <div className="rating">
                  <div className="ratingTitle">امتیاز</div>
                  <Rating onClick={handleRating} ratingValue={rating} />
                </div>
                <span
                  className={`error-respns ${state.validInput ? "active" : ""}`}
                >
                  <i className="icon-exclamation-mark"></i>
                  متن پیام خود را وارد کنید
                </span>
              </div>
              <div className="btn-base btn-black btn-sircle">
                <Button variant="contained" onClick={handleSetComment}>
                  تایید
                </Button>
              </div>
            </div>
          </div>

          <div className="comments-list">
            <h4>نظرات کاربران</h4>
            <div className="inner-listcmnt">
              {state.data.length == 0 ? (
                state.loading ? (
                  <div className="spinner">
                    <HalfCircleSpinner
                      size={40}
                      color="#000"
                      active={state.loader}
                    />
                  </div>
                ) : (
                  <span className="no-content">نطری وجود ندارد</span>
                )
              ) : (
                state.data.map((info) => <ItemComment data={info} />)
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Comments;
